import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';

interface DetailViewBodyProps {
    className?: string;
    children?: React.ReactNode;
}

const useDetailViewCodyStyles = createUseStyles({
    detailViewBody: {
        flex: 1,
        padding: '32px 30px',
        width: '100%',
    },
});

export const DetailViewBody: FC<DetailViewBodyProps> = ({ className, children }) => {
    const classes = useDetailViewCodyStyles();

    return <div className={classNames(classes.detailViewBody, className)}>{children}</div>;
};
